import AppBar from '../ui/AppBar';
import Header from '../ui/Header';
import Meta from './Meta';

type LayoutProps = {
  title?: string;
  showNav?: boolean;
  appShell?: boolean;
  children: React.ReactNode;
};

const Layout = ({ title, showNav, appShell, children }: LayoutProps) => {
  return (
    <>
      <Meta title={title} />
      <div className="min-h-dyn flex flex-col">
        <Header navigation={showNav} />
        <AppShell enabled={appShell}>
          <main className="grow px-4 pt-8 md:pt-6">{children}</main>
        </AppShell>
      </div>
    </>
  );
};

type AppShellProps = {
  enabled?: boolean;
  children: React.ReactNode;
};

const AppShell = ({ enabled, children }: AppShellProps) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <div className="flex grow">
      <AppBar />
      {children}
    </div>
  );
};

export default Layout;
